var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',[_c('vnt-header',{staticClass:"header"},[_vm._v("Categories")]),_c('vnt-button',{staticClass:"add-button",attrs:{"click":_vm.addCategory}},[_vm._v("Add")]),_c('categories-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }